<template>
  <UserProperty
    @dataAvailable="
      data => {
        userData = data || {}
      }
    "
  />
  <div class="h-full p-8 pb-0 pt-0 w-full flex flex-col">
    <div>
      <div
        class="pb-8 md:pb-3 p-3 rounded-lg"
        v-for="(message, i) in loading ? shimmerMessages : messages"
        :key="i"
      >
        <div
          class="flex items-start"
          :class="{
            'flex-row': message.isShimmer
              ? message.leftSide
              : message.senderReference !== senderId,
            'flex-row-reverse': message.isShimmer
              ? !message.leftSide
              : message.senderReference == senderId,
          }"
        >
          <div
            class="flex items-center justify-center h-14 overflow-hidden w-14 rounded-full y flex-shrink-0"
            :class="{
              shimmerElement: message.isShimmer,
              ' bg-primary-200': message.isShimmer
                ? message.leftSide
                : message.senderReference !== senderId,
              ' bg-secondary-400': message.isShimmer
                ? !message.leftSide
                : message.senderReference == senderId,
            }"
          >
            <img
              v-if="message.senderReference == senderId"
              :src="
                userData?.metaData?.rawUser?.metadata?.pictureUrl ||
                userData.profilePictureUrl
              "
              alt=""
              class="w-full h-full"
            />
            <img
              v-else
              src="/images/logo.png"
              alt=""
              class="object-contain w-full h-full"
            />
          </div>
          <div>
            <div
              class="px-4 flex gap-8"
              :class="{
                shimmerElement: message.isShimmer,
                'text-right flex-row-reverse': message.isShimmer
                  ? !message.leftSide
                  : message.senderReference == senderId,
              }"
            >
              <div class="text-sm md:text-xl font-semibold title-color">
                <span v-if="message.senderReference == senderId">
                  {{ userData?.firstName }}
                </span>
                <span v-else> Assistance EkiDiscount </span>
              </div>
              <div>
                {{ $Commons.time(message.timestamp, 'DD MMM YYYY, hh:mm') }}
              </div>
            </div>
            <div
              class="relative py-4 px-4 text-md md:text-lg rounded-3xl max-w-[500px]"
              :class="{
                shimmerElement: message.isShimmer,
                'ml-3 bg-white title-color !rounded-tl-[0]': message.isShimmer
                  ? message.leftSide
                  : message.senderReference !== senderId,
                'mr-3 border text-white  bg-primary !rounded-tr-[0]':
                  message.isShimmer
                    ? !message.leftSide
                    : message.senderReference == senderId,
              }"
            >
              <TextComponent>
                {{ message.content }}
              </TextComponent>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="flex flex-col gap-1 rounded-t-2xl border bg-white w-full pt-1 p-4 sticky bottom-0"
    >
      <div class="flex-grow ml-0">
        <div class="relative w-full">
          <FormComponent
            class="[&_.inputContainer]:border-none [&_.inputContainer]:bg-transparent [&_.inputContainer]:h-[40px] [&_.inputContainer]:m-[0px] [&_input]:bg-[transparent] w-full"
            :class="{
              'shimmerElementRoundedDefault rounded-lg': downloadingData,
            }"
            ref="messageInpuForm"
            :fields="[
              {
                type: 'textarea',
                propertyName: 'text',
                placeHolder: 'Votre message',
                defaultValue: '',
              },
            ]"
            @fieldChanged="
              data => {
                newMessage = data.text
              }
            "
            @formSubmited="
              data => {
                newMessage = data.text
                this.sendNewMessage()
              }
            "
          >
            <template #submitButton><div></div> </template>
          </FormComponent>
        </div>
      </div>
      <div class="flex justify-between">
        <div class="flex">
          <!-- <button
            class="h-full w-12 right-0 top-0 text-gray-400 hover:text-gray-600"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </button>
          <button
            class="flex items-center justify-center text-gray-400 hover:text-gray-600"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
              ></path>
            </svg>
          </button> -->
        </div>
        <div class="ml-4">
          <button
            class="flex items-center justify-center bg-primary-500 hover:bg-primary-600 rounded-xl text-white px-4 py-1.5 flex-shrink-0"
            @click="sendNewMessage"
          >
            <span>Envoyer</span>
            <span class="ml-2">
              <svg
                class="w-4 h-4 transform rotate-45 -mt-px"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                ></path>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserProperty from '@/components/user/UserProperty.vue'
import FormComponent from '@/components/utils/FormComponent.vue'

export default {
  name: 'homeComponent',
  components: { FormComponent, UserProperty },
  data() {
    return {
      eventsIds: [],
      activeTab: 'home',
      loading: false,
      chatData: {
        metaData: {
          user: {
            firstName: 'Alice',
            lastName: 'Johnson',
            phoneNumber: '+1234567890',
            email: 'alice.johnson@example.com',
          },
        },
      },
      userData: {},
      senderId: 'user123',
      messages: [
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Salut, comment ça va ?',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:05:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Ça va bien, merci ! Et toi ?',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:07:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Tout va bien de mon côté aussi.',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:08:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Tu as vu le dernier film sorti ?',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:10:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Oui, il était incroyable !',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:12:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'On devrait le revoir ensemble.',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:15:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Bonne idée, quand es-tu disponible ?',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:17:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Ce week-end, ça te va ?',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:20:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Oui, parfait !',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:22:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Super, à samedi alors !',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:25:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'À samedi !',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:26:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: "Tu veux qu'on aille manger après ?",
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:30:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Avec plaisir, tu as un endroit en tête ?',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:32:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Oui, ce nouveau restaurant italien.',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:35:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: "J'adore l'italien, c'est parfait !",
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:37:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Je réserve une table pour 20h.',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:40:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Parfait, merci !',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:42:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'De rien, à samedi !',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:45:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'À samedi !',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:46:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Tu as prévu quelque chose pour dimanche ?',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:50:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Non, pas encore. Pourquoi ?',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:52:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'On pourrait faire une randonnée.',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T10:55:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: "Bonne idée, j'adore ça !",
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T10:57:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Je vais préparer le parcours.',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T11:00:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Génial, merci !',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T11:02:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'De rien, à dimanche alors !',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T11:05:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'À dimanche !',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T11:06:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Tu as besoin que je vienne te chercher ?',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T11:10:00Z',
        },
        {
          senderReference: 'user123',
          senderName: 'Alice',
          content: 'Oui, ce serait super, merci !',
          isShimmer: false,
          leftSide: false,
          timestamp: '2023-10-25T11:12:00Z',
        },
        {
          senderReference: 'user456',
          senderName: 'Bob',
          content: 'Pas de problème, à dimanche !',
          isShimmer: false,
          leftSide: true,
          timestamp: '2023-10-25T11:15:00Z',
        },
      ],
      shimmerMessages: [
        {
          isShimmer: true,
          leftSide: true,
        },
        {
          isShimmer: true,
          leftSide: false,
        },
        {
          isShimmer: true,
          leftSide: true,
        },
      ],
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    addNewProduct() {
      this.$Events.dispatchEvent('new_product_adding_required')
    },
  },
}
</script>
